import type { UtmParameters } from '@/Shared/Service/Tracking/Utm/UtmParameters'

export class UtmUrlBuilder {
    public build(destinationUrl: string, parameters: UtmParameters): string {
        const url = new URL(destinationUrl)

        url.searchParams.set('utm_source', parameters.source)

        if (parameters.medium !== null) {
            url.searchParams.set('utm_medium', parameters.medium)
        }

        if (parameters.content !== null) {
            url.searchParams.set('utm_content', parameters.content)
        }

        return url.toString()
    }
}
